import Vue from "vue"
import Vuex from "vuex"
import langs from "@common-store/langs"
import user from "@common-store/user"

Vue.use(Vuex)

const modules = {
    langs,
    user
}

export default new Vuex.Store({
    modules
})
